import PageTitle from '../../Components/PageTitle';
import Navbar from '../../Components/Navbar';
import { useTranslation } from 'react-i18next';
import './homeStyles.css';

export default function Home(){
    const { t, i18n } = useTranslation();
    return (
        <>
          <Navbar currentPage={"home"}></Navbar>
          <div className="page-shell">
          <PageTitle title="Home"></PageTitle>

          <p className="home-card">
          {t('home.stocksStrategy')}
          </p>
          <p className="home-card">
          {t('home.secondSection')}
          </p>
        </div>
      </>
    );
}

